export enum PageStyleEnum {
  ACTIVITIES = 'activities',
  CALENDAR = 'calendar',
}
